import React from "react";

const WFIRSSQuestion1 = ({ questions, renderRadioInputs, questionKey }) => (
  <div key={`WFIRSSQuestion1${questionKey}`}>
    <div className="wfirs-progress-row">
      <div className="wfirs-progress-bar">
        <div style={{ width: "14.3%" }}></div>
      </div>
      <span className="wfirs-counter">1 / 7</span>
    </div>
    <h2 className="wfirs-section-title">Click the number for the rating that best describes how your emotional or behavioral problems have affected your family.</h2>
    {questions.slice(0, 8).map((question, index) => (
      <div className="wfirs-question" key={index}>
        <label className="wfirs-q-label">{index + 1}. {question.questions}</label>
        {renderRadioInputs(index + 1)}
      </div>
    ))}
  </div>
);

export default WFIRSSQuestion1;
